import {
  faBasketShopping,
  faHeart,
  faSortDown,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Product_Info_Card.css";
import React, { useContext, useState } from "react";
import { Button } from "react-bootstrap";
import Green_Btn from "../common_btn/green_btn/Green_Btn";
import { useNavigate } from "react-router-dom";
import { Context } from "../../../utils/context";
import Login_Modal from "../../Common_modal/login_modal/Login_Modal";
import { encodeId } from "../../../utils/common";

const Product_Info_Card = ({ item, product, showQty }) => {
  const { IMG_URL, shimmerLoader, setShimmerLoader, signin } =
    useContext(Context);

  const [modalLShow, setModalLShow] = useState(false);
  const [count, setCount] = useState(0);

  const [favouriteProduct, setFavouriteProduct] = useState();

  const navigate = useNavigate();

  const [addcartmodal, Setaddcartmodal] = useState(false);

  const variant = product?.product_variants?.[0];

  const mrp = parseFloat(variant?.mrp || 0);
  const s_price = parseFloat(variant?.s_price || 0);
  const vName = variant?.v_name || "";
  const unit = variant?.unit || "";

  const discount = mrp > 0 ? Math.round(((mrp - s_price) / mrp) * 100) : 0;

  console.log(product, "product product product");

  console.log(
    product?.discount_type === "percentage",
    "product?.discount_type",
  );

  return (
    <section className="Product_Info_Grid_View_Section Product_Info_Card">
      <div className="Product_Info_Grid_View">
        {/* <div
          className="upper_image_section"
          onClick={() => navigate("/vendor-page")}
        > */}
        <div
          className="upper_image_section"
          onClick={() => navigate(`/vendor-page/${encodeId(product?.id)}`)}
        >
          <div className="card_img_holder">
            <img
              className=""
              src={IMG_URL + product?.image1}
              alt={product?.name}
            />
          </div>

          {product?.company && (
            <div class="company_div">
              <p class="company_text">{product?.company}</p>
            </div>
          )}
        </div>

        <div className="lower_text_section">
          {/* <p
            className="product_name"
            onClick={() => {
              navigate("/vendor-page");
            }}
          > */}

          <p
            className="product_name"
            onClick={() => navigate(`/vendor-page/${encodeId(product?.id)}`)}
          >
            {product?.name}
          </p>

          <div className="pricing_div">
            <div className="left_side">
              <p className="selling_price">
                ₹
                {product?.product_variants?.length > 0
                  ? product.product_variants[0].s_price
                  : ""}
              </p>
              <p className="mrp">
                ₹
                {product?.product_variants?.length > 0
                  ? product.product_variants[0].mrp
                  : ""}
              </p>
              {/* <div className='discount_div'>
                                <p className='discount'>{product?.discount}</p>
                            </div> */}
            </div>

            {item?.discount_type && (
              <div className="text_div">
                <div className="discont_div">
                  <p className="discount_text">
                    {item?.discount_type === "percentage"
                      ? `${item?.discount}%`
                      : `₹${item?.discount}`}
                  </p>
                  <p className="discount_text">Off</p>
                </div>
              </div>
            )}
          </div>

          <div className="text-center btn_holder">
            {showQty && (
              <div
                className="kilo_main_div"
                onClick={() =>
                  navigate(`/vendor-page/${encodeId(product?.id)}`)
                }
              >
                <div
                  className="kilo_div"
                  type="button"
                  onClick={() => Setaddcartmodal(true)}
                >
                  <div>
                    <p className="kilo_text">
                      {" "}
                      {vName}
                    </p>
                  </div>
                  {/* <div>
                    <p className="icon_p">
                      <FontAwesomeIcon
                        icon={faSortDown}
                        className="down_icon"
                      />
                    </p>
                  </div> */}
                </div>
              </div>
            )}

            <div className="cart_btn_div">
              {/* <Green_Btn
                leftIcon={faBasketShopping}
                onClick={() => {
                  setShowIncrement(true);
                  Setaddcartmodal(true);
                }}
              /> */}

              <Green_Btn
                leftIcon={faBasketShopping}
                onClick={() =>
                  navigate(`/vendor-page/${encodeId(product?.id)}`)
                }
              />
            </div>
          </div>

          {/* <div
            className="favourite_div"
            onClick={() => {
              if (!signin) {
                setModalLShow(true);
                setCount((c) => c + 1);
                return;
              }

              setFavouriteProduct((prev) =>
                prev === product?.id ? null : product?.id,
              );
            }}
          >
            <FontAwesomeIcon
              icon={faHeart}
              className={`heart_icon ${
                favouriteProduct === product?.id ? "active" : ""
              }`}
            />
          </div> */}
        </div>
      </div>

      <Login_Modal
        key={count}
        show={modalLShow}
        onHide={() => setModalLShow(false)}
      />
    </section>
  );
};
export default Product_Info_Card;
